import React, { useState, useEffect } from "react";
import { X, Search, Check, Image as ImageIcon } from "lucide-react";
import { getPhotoBoardList } from "../../../api/const"; // API adjust if needed

export default function MobilePhotoBoardSelect({
    isOpen,
    projectId,
    onSelect,
    onClose,
    selectedId
}) {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState("");

    useEffect(() => {
        if (!projectId || !isOpen) return;
        setLoading(true);
        getPhotoBoardList({ project_id: projectId })
            .then((res) => setList(res.data || []))
            .catch((e) => console.error(e))
            .finally(() => setLoading(false));
    }, [projectId, isOpen]);

    // 모달이 닫혀있으면 렌더링하지 않음
    if (!isOpen) return null;

    const filtered = list.filter(item =>
        (item.title || "").toLowerCase().includes(query.toLowerCase())
    );

    return (
        <div className="fixed inset-0 z-[60] bg-white flex flex-col animate-in slide-in-from-bottom border-t-2 border-slate-100">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-white sticky top-0 z-10 safe-area-top">
                <h3 className="text-lg font-bold text-slate-800">사진대지 선택</h3>
                <button onClick={onClose} className="p-2 -mr-2 text-slate-400 hover:text-slate-600">
                    <X size={24} />
                </button>
            </div>

            {/* Search */}
            <div className="p-4 bg-white border-b border-gray-100">
                <div className="relative">
                    <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
                    <input
                        value={query}
                        onChange={e => setQuery(e.target.value)}
                        placeholder="제목 검색"
                        className="w-full bg-gray-50 h-10 rounded-xl pl-10 pr-4 text-sm outline-none focus:ring-2 focus:ring-blue-100 transition-all"
                    />
                </div>
            </div>

            {/* List */}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50">
                {loading ? (
                    <div className="text-center py-10 text-slate-400 text-sm">로딩 중...</div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-10 text-slate-400 text-sm">데이터가 없습니다.</div>
                ) : (
                    filtered.map((item) => {
                        const isSelected = selectedId === item.id;
                        return (
                            <button
                                key={item.id}
                                onClick={() => {
                                    onSelect(item);
                                    onClose();
                                }}
                                className={`w-full text-left p-3 rounded-xl border transition-all flex items-center gap-3 ${isSelected
                                    ? "bg-blue-50 border-blue-200 shadow-sm"
                                    : "bg-white border-gray-200 shadow-sm hover:border-blue-100"
                                    }`}
                            >
                                <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden ${isSelected ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-400"
                                    }`}>
                                    <ImageIcon size={24} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h4 className={`font-bold text-sm mb-0.5 truncate ${isSelected ? "text-blue-900" : "text-gray-800"}`}>
                                        {item.title}
                                    </h4>
                                    <div className="flex items-center gap-2 text-xs text-slate-500">
                                        <span>{item.created_at?.slice(0, 10)}</span>
                                        <span>•</span>
                                        <span>{item.created_by?.name || "작성자 미상"}</span>
                                    </div>
                                </div>
                                {isSelected && <Check size={20} className="text-blue-500 mr-1" />}
                            </button>
                        );
                    })
                )}
            </div>
        </div>
    );
}
